<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8331 1.73642C10.5596 1.69018 10.2809 1.6665 9.99981 1.6665C8.67373 1.6665 7.40196 2.19329 6.46428 3.13097C5.5266 4.06865 4.99981 5.34042 4.99981 6.6665C4.99981 9.24166 4.3502 11.0048 3.62453 12.171C3.01242 13.1547 2.70636 13.6466 2.71758 13.7838C2.73001 13.9357 2.7622 13.9937 2.88463 14.0845C2.99519 14.1665 3.49364 14.1665 4.49052 14.1665H6.46428M15.3212 9.58317C15.5792 10.6622 15.9649 11.5118 16.375 12.1708C16.9871 13.1547 17.2932 13.6466 17.282 13.7838C17.2695 13.9357 17.2374 13.9937 17.1149 14.0845C17.0044 14.1665 16.5059 14.1665 15.5091 14.1665H13.75M13.75 14.1665C13.3455 15.9662 13.0595 16.6829 12.2047 17.4998C11.6171 18.0185 10.8452 18.3332 9.99981 18.3332C9.15444 18.3332 8.38257 18.0185 7.79496 17.4998C6.82862 16.4845 6.56166 15.7242 6.46428 14.1665M13.75 14.1665H6.46428M10.625 4.99984L12.5 6.87484L16.375 3.13097"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
